var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page4-container" }, [
    _c("div", { staticClass: "content-header" }, [
      _vm.steps[1] && _vm.steps[1].html
        ? _c("div", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.steps[1].html) }
          })
        : _c("p", { staticClass: "title" }, [
            _vm._v("Step 2: Select a Box Design")
          ]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v("These will fit your items perfectly!")
      ])
    ]),
    _vm._v(" "),
    _vm.bestBoxes.length == 0
      ? _c("p", { staticClass: "over-budget" }, [
          _vm._v("You're currently over your allotted budget. "),
          _c("br"),
          _vm._v(
            " Please remove some items from your gift to be able to add more items."
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.bestBoxes.length > 0
      ? _c(
          "ul",
          { staticClass: "boxes-container" },
          _vm._l(_vm.bestBoxes, function(box) {
            return _c("li", { key: box.id }, [
              _c("div", { staticClass: "box-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "main-image-container",
                    class:
                      _vm.selectedBoxProduct &&
                      _vm.selectedBoxProduct.id == box.id
                        ? "selected"
                        : ""
                  },
                  [
                    _vm.selectedBoxProduct &&
                    _vm.selectedBoxProduct.id == box.id
                      ? _c("img", {
                          staticClass: "green-check",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "main-image lazyload",
                      attrs: {
                        width: "280",
                        height: "280",
                        "data-src": _vm._f("getProductImage")(box)
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectBox(box)
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "box-title" }, [
                  _vm._v(_vm._s(box.title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "box-desc" }, [
                  _vm._v(_vm._s(_vm._f("moneyFormat")(box)))
                ]),
                _vm._v(" "),
                _vm.selectedBoxProduct && _vm.selectedBoxProduct.id == box.id
                  ? _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        on: {
                          click: function($event) {
                            return _vm.changePage(true)
                          }
                        }
                      },
                      [_vm._v("Next")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "happybox-button white border",
                        on: {
                          click: function($event) {
                            return _vm.selectBox(box)
                          }
                        }
                      },
                      [_vm._v("Select Design")]
                    )
              ])
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.extendedProducts && _vm.isExtendedBoxes
      ? _c("div", { staticClass: "box-warning" }, [
          _vm._v("\n        Want to see more box options? "),
          _c("br"),
          _vm._v(" Remove "),
          _c("strong", [_vm._v(_vm._s(_vm.extendedProducts))]),
          _vm._v(" to see more designs and sizes!\n    ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }